import { List, Set } from 'immutable';
import { parametric, pathSubscription, regSub, subscription } from 'nike-re-framejs';

export const activeMark = pathSubscription(['ticketus', 'active', 'mark']);
export const activeSportEventIds = pathSubscription(['ticketus', 'active', 'sportEventIds'], Set());
export const activeTicketsCount = parametric(sportEventId =>
    subscription(db => db.getIn(['ticketus', 'active', 'sportEventToTickets', sportEventId], List()).size)
);
export const activeMatchTickets = pathSubscription(['ticketus', 'active', 'match', 'tickets'], List());
export const activeMatchBetHasTicket = parametric(betId =>
    subscription(db => !!db.getIn(['ticketus', 'active', 'match', 'betIdsToPickIds', betId]))
);
export const activeMatchSelectionHasTicket = parametric((betId, selection) =>
    subscription(db => db.getIn(['ticketus', 'active', 'match', 'betIdsToPickIds', betId], Set()).has(selection))
);
regSub('ticketus/active/match/selectionHasTicket', (db, [_, betId, selection]) =>
    db.getIn(['ticketus', 'active', 'match', 'betIdsToPickIds', betId], Set()).has(selection)
);
